import React, { useEffect, useMemo, useRef, useState } from 'react'
import { GenericObjectType, StrictRJSFSchema } from '@rjsf/utils'
import jp from 'jsonpath'

import { useOutsideScroll } from '../../../../../common/useOutsideScroll'
import { useOutsideClick } from '../../../../../common/useOutsideClick'

import { selectResultExplainerIsLoading } from '../../../../../store/meetingSummary/meetingSupport'
import { selectRoomSession } from '../../../../../store/meetingSummary/roomSession'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'

import { getFieldIdParts, getJsonPathFromPathParts } from '../../../../../views/UpdateExternalContact/utils'
import { UpdateExternalContactFormProps } from '../../../../../views/UpdateExternalContact/models'

import { useExplainFieldResult } from '../hooks/api'

import { ResultExplainerView } from './ResultExplainerView'
import { ExplainedResult } from './models'

interface ExternalContactUpdateResultExplainerProps {
  schema: StrictRJSFSchema & GenericObjectType
  value: string
  formContext: UpdateExternalContactFormProps
  fieldId: string
  onClose: () => void
}

export const ExternalContactUpdateResultExplainer: React.FC<ExternalContactUpdateResultExplainerProps> = ({ schema, value, formContext, fieldId, onClose }) => {
  const { rootFieldId, contactValues } = formContext

  const roomSession = useAppSelector(selectRoomSession)
  const isExplainResultLoading = useAppSelector(selectResultExplainerIsLoading)
  const dispatch = useAppDispatch()

  const explainFieldResult = useExplainFieldResult()

  const [explanationResult, setExplanationResult] = useState<ExplainedResult | null>(null)

  const objectValue = useMemo(() => {
    const jsonPath = getJsonPathFromPathParts(getFieldIdParts(rootFieldId, fieldId).slice(0, -1))
    if (!jsonPath) {
      return null
    }
    return jp.value(contactValues, jsonPath)
  }, [rootFieldId, fieldId, contactValues])

  const containerRef = useRef<HTMLDivElement>(null)

  useOutsideClick(containerRef, () => {
    onClose()
  })

  useOutsideScroll(containerRef, () => {
    onClose()
  })

  useEffect(() => {
    if (!value || !schema || !objectValue) {
      return
    }

    const executeExplainFieldResult = async () => {
      const explanationResult = await explainFieldResult(value, schema, objectValue)
      setExplanationResult(explanationResult)
    }

    executeExplainFieldResult()
  }, [objectValue, schema, dispatch, explainFieldResult, value])

  return (
    <div ref={containerRef}>
      <ResultExplainerView resultToExplain={value ?? ''} explanationResult={explanationResult} isLoading={isExplainResultLoading} roomSession={roomSession} />
    </div>
  )
}
